import { exhaustiveGuard, isStringLiteralOfType } from "@mcwd/typescript-type-guards";
import type { GatingLevel } from "../../types/definitions/gating/gating-level.js";

export function getResourceGatingLevel(resource: { gatingLevel: GatingLevel.Resource.Raw }): GatingLevel.Resource.Parsed {
  if (isStringLiteralOfType(resource.gatingLevel, ["Full Gate", "FullGate"])) {
    return "FullGate";
  }
  else if (isStringLiteralOfType(resource.gatingLevel, ["Partial Gate", "PartialGate"])) {
    return "PartialGate";
  }
  // Currently Resources are assigned the value "Ungated" when they should not be gated (aka the "NoGate" gatinglevel). 
  // We just return "NoGate" here so we don't get this state confused with the "BlindSubmit" state or regular form completions which are also called "Ungated"
  // I've also added checks here for "No Gate" and "No Gate" in case we change the way these are assigned to resources in the near future.
  else if (isStringLiteralOfType(resource.gatingLevel, ["Ungated", "No Gate", "NoGate"])) {
    return "NoGate";
  }
  else {
    return exhaustiveGuard(resource.gatingLevel, "Unexpected gating level assigned to resouce");
  }
}